import { useRef, useState, useEffect, React } from "react";
import { useBlogContext } from "../../fetchdata/BlogContext";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import axiosInstance, { Homeurl } from "../../axiosInstance";
import { Pagination, Navigation } from "swiper/modules";
import RangeSlider from "../components/extra/RangeSlider";
import { Helmet } from "react-helmet";
import CreateSlug from "../components/extra/CreateSlug";
 

const Category = () => {
  const { Headers, isHeader } = useBlogContext();
  const formatContactNumber = (number) => {
    const digits = String(number || "").replace(/\D/g, "");
    return digits.length === 10 ? `91${digits}` : digits;
  };
  const callNumber = formatContactNumber(Headers?.phone);
  const whatsappNumber = formatContactNumber(Headers?.whatsapp || Headers?.phone);
  const callHref = callNumber ? `tel:+${callNumber}` : "#";
  const whatsappHref = whatsappNumber ? `https://api.whatsapp.com/send/?phone=%2B${whatsappNumber}` : "#";
  const navigate = useNavigate();
  const [enquireData, setEnquireData] = useState({
    fullname: "",
    email: "",
    phone: "",
    service: "",
    Requirement: "",
  });
  const [layout, setLayout] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isProducts, setIsProducts] = useState(true);
  const [RProducts, setRProducts] = useState([]);

  const getProducts = async () => {
    try {
      const { data } = await axiosInstance.get("/all-home-products");
      setRProducts(data.products);
      setIsProducts(false);
    } catch (error) {
      console.error("Error fetching products:", error);
      setIsProducts(false);
    }
  };

  const getData = async () => {
    try {
      const { data } = await axiosInstance.get(`/home-layout-data`);
      setLayout(data.homeLayout);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      toast.error("Error fetching Home layout!");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
    getProducts();
  }, []);

  const [selectedRanges, setSelectedRanges] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [Cat, setCat] = useState([]);
  const [CatT, setTCat] = useState([]);
  const [CatImage, setTCatImage] = useState("");
  const [CatM, setMCat] = useState([]);
  const [Pro, setPro] = useState([]);
  const [Attr, setAttr] = useState([]);
  const [fillter, setfillter] = useState("");
  const [Viewfillter, setViewfillter] = useState([]);
  const [isCat, setIsCat] = useState(true);
  const [count, setcount] = useState("100");
  const [Sidebar, setIsSidebar] = useState(false);

  const handlecountChange = (event) => setcount(event.target.value);

  const { id } = useParams();
  const [products, setProducts] = useState([]);
  const [ratings, setRatings] = useState([]);

  const getRating = async () => {
    try {
      const { data } = await axiosInstance.get(`/all-rating`);
      setRatings(data.ratings);
    } catch (error) {
      console.error("Error fetching rating:", error);
    }
  };

  const [Specifications, setspecifications] = useState([]);

  const getCategory = async (fillter, page, price) => {
    setIsSidebar(false);
    if (window.__PRELOADED_DATA__?.MainCat?.slug !== id || window.__PRELOADED_DATA__ === undefined) {
      try {
        window.scrollTo(0, 0);
        setIsCat(true);
        const encodedFilter = encodeURIComponent(fillter);
        const { data } = await axiosInstance.get(
          `/all/category-slug/${id}?filter=${encodedFilter}&price=${price}&page=${page}&perPage=${count}`
        );
        setCat([]); setTCat([]); setMCat([]);
        if (data?.success) {
          setCat(data?.categories);
          setTCat(data.MainCat);
          setEnquireData((prev) => ({ ...prev, service: data.MainCat?.title }));
          setspecifications(data.MainCat.specifications.specifications || []);
          setTCatImage(data.MainCat.image);
          setTotalPages(data?.proLength);
          setfillter(fillter);
          setProducts(data?.productsFilter);
          setPro(data?.products);
          setMCat(data?.MainCat);
        }
      } catch (error) {
        console.log(error);
        toast.error("Error fetching Category!");
        navigate("/404");
      } finally {
        setIsCat(false);
      }
    } else {
      setCat([]); setTCat([]); setMCat([]);
      setCat(window.__PRELOADED_DATA__?.categories);
      setTCat(window.__PRELOADED_DATA__.MainCat);
      setEnquireData((prev) => ({ ...prev, service: window.__PRELOADED_DATA__.MainCat?.title }));
      setspecifications(window.__PRELOADED_DATA__.MainCat.specifications.specifications || []);
      setTCatImage(window.__PRELOADED_DATA__.MainCat.image);
      setTotalPages(window.__PRELOADED_DATA__?.proLength);
      setfillter(fillter);
      setProducts(window.__PRELOADED_DATA__?.productsFilter);
      setPro(window.__PRELOADED_DATA__?.products);
      setMCat(window.__PRELOADED_DATA__?.MainCat);
      setIsCat(false);
    }
  };

  const getAttribute = async () => {
    try {
      const { data } = await axiosInstance.get("/all-attribute");
      setAttr(data.Attribute);
    } catch (error) {
      console.error("Error fetching attributes:", error);
    }
  };

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    setSelectedFilters((prev) => {
      if (checked) return { ...prev, [value]: checked };
      const { [value]: _, ...rest } = prev;
      return rest;
    });
    setCurrentPage(1);
  };

  const removeFilter = ({ key, val }) => {
    const value = `${key},${val}`;
    setSelectedFilters((prev) => {
      const { [value]: _, ...rest } = prev;
      return rest;
    });
    setCurrentPage(1);
  };

  const generateQueryString = () => {
    const filterObj = {};
    Object.entries(selectedFilters).forEach(([key]) => {
      const [attrKey, attrValue] = key.split(",");
      if (filterObj[attrKey]) filterObj[attrKey] += `,${attrValue}`;
      else filterObj[attrKey] = attrValue;
    });
    const filterString = JSON.stringify(filterObj);
    setViewfillter(filterString);
    setTimeout(() => getCategory(filterString, currentPage, selectedRanges), 100);
  };

  useEffect(() => {
    generateQueryString();
    getRating();
    setIsCat(true);
    getAttribute();
  }, [id, currentPage, selectedFilters, selectedRanges, count]);

  useEffect(() => { setSelectedRanges([]); }, [id]);

  const maxSalePrice = Math.max(...products.map((p) => p.salePrice), 0);
  const numRanges = Math.ceil(maxSalePrice / 10000);
  const priceRanges = Array.from({ length: numRanges }, (_, i) => ({ min: i * 10000, max: (i + 1) * 10000 }));
  const filteredPriceRanges = priceRanges.filter((range) =>
    products.some((p) => p.salePrice >= range.min && p.salePrice < range.max)
  );

  const handleCheckpriceboxChange = (event) => {
    const { value, checked } = event.target;
    if (checked) setSelectedRanges([...selectedRanges, value]);
    else setSelectedRanges(selectedRanges.filter((r) => r !== value));
    setCurrentPage(1);
  };

  const handlePageChange = (page) => setCurrentPage(page);

  const [EnquireShow, setEnquireShow] = useState(false);
  const [EnquireStatus, setEnquireStatus] = useState(false);

  const capitalizeEachWord = (str) => {
    if (!str) return str;
    str = str.replace(/\d+/g, "");
    return str.split(" ").map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(" ");
  };

  const validate = (email) => {
    const invalidCharsRegex = /[^\w@_.]| /;
    if (email === "-" || email === "+") return "";
    if (invalidCharsRegex.test(email)) return "";
    return email;
  };

  const handleEnquireChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newValue = type === "checkbox" ? checked : value;
    if (name === "fullname") newValue = capitalizeEachWord(newValue);
    if (name === "email") newValue = validate(newValue);
    if (name === "phone") {
      newValue = value.replace(/\D/g, "");
      if (newValue.length > 13) newValue = newValue.slice(0, 13);
    }
    setEnquireData((prev) => ({ ...prev, [name]: newValue }));
  };

  const getSavedUserLocation = () => {
    try {
      const savedLocation = localStorage.getItem("userLocation");
      if (!savedLocation) return null;
      const parsedLocation = JSON.parse(savedLocation);
      if (!parsedLocation?.lat || !parsedLocation?.lng) return null;

      return {
        location: parsedLocation.location || "",
        lat: String(parsedLocation.lat),
        lng: String(parsedLocation.lng),
      };
    } catch (error) {
      console.error("Error reading saved user location:", error);
      return null;
    }
  };

  const handleSendEnquire = async () => {
    const fields = [
      { name: "fullname", message: "Please enter Full Name" },
      { name: "phone",    message: "Please enter phone number" },
      { name: "email",    message: "Please enter email" },
      { name: "Requirement", message: "Please enter Requirement" },
    ];
    for (const field of fields) {
      if (!enquireData[field.name]) { toast.error(field.message); setEnquireStatus(false); return; }
    }
    try {
      setEnquireStatus(true);
      const savedLocation = getSavedUserLocation();
      if (!savedLocation?.lat || !savedLocation?.lng) {
        alert("Please choose location");
        setEnquireStatus(false);
        return;
      }
      const enquirePayload = {
        ...enquireData,
        location: savedLocation.location || "",
        lat: savedLocation.lat || "",
        lng: savedLocation.lng || "",
        Requirement: enquireData.Requirement || "",
        QTY: "",
      };
      await toast.promise(axiosInstance.post(`/send-enquire`, enquirePayload), {
        loading: "Submitting enquiry…",
        success: "Enquiry submitted successfully!",
        error:   "Failed to submit enquiry.",
      });
      setEnquireData((prev) => ({ ...prev, fullname: "", email: "", phone: "", Requirement: "" }));
    } catch (error) {
      console.error("Failed to send email:", error);
    } finally {
      setEnquireStatus(false);
    }
  };

  /* ─── RENDER ─────────────────────────────── */
  return (
    <>
      <Header />

      <div className="cat-page-wrap">
        <div className="container py-4 py-lg-5">
          <div className="row g-4">

            {/* ── LEFT: Enquiry sidebar ── */}
            <div className="col-lg-3 col-md-4">
              <div className="cat-sidebar-card">
                {/* Header */}
                <div className="cat-sidebar-head">
                  <h5>
                    <i className="ri-customer-service-2-line me-2" />
                    Quick Enquiry
                  </h5>
                  {CatT?.title && (
                    <small>For {CatT.title}</small>
                  )}
                </div>

                {/* Body */}
                <div className="cat-sidebar-body">
                  <div className="mb-3">
                    <label className="cat-label">Full Name <span className="text-danger">*</span></label>
                    <input type="text" name="fullname" className="form-control cat-input"
                      placeholder="John Doe"
                      value={enquireData.fullname || ""}
                      onChange={handleEnquireChange} />
                  </div>
                  <div className="mb-3">
                    <label className="cat-label">Phone Number <span className="text-danger">*</span></label>
                    <input type="number" name="phone" className="form-control cat-input"
                      placeholder="+91 XXXXX XXXXX"
                      value={enquireData.phone || ""}
                      onChange={handleEnquireChange} />
                  </div>
                  <div className="mb-3">
                    <label className="cat-label">Email Address <span className="text-danger">*</span></label>
                    <input type="email" name="email" className="form-control cat-input"
                      placeholder="you@example.com"
                      value={enquireData.email || ""}
                      onChange={handleEnquireChange} />
                  </div>
                  <div className="mb-4">
                    <label className="cat-label">Requirement <span className="text-danger">*</span></label>
                    <textarea name="Requirement" rows="3" className="form-control cat-input"
                      placeholder="Describe your requirement…"
                      value={enquireData.Requirement || ""}
                      onChange={handleEnquireChange} />
                    <input type="hidden" name="service" value={enquireData?.service || ""} />
                  </div>
                  <button className="cat-btn-submit" onClick={handleSendEnquire} disabled={EnquireStatus}>
                    {EnquireStatus
                      ? <><i className="ri-loader-4-line me-2" style={{ animation: "spin 1s linear infinite" }} />Sending…</>
                      : <><i className="ri-send-plane-2-line me-2" />Send Enquiry</>
                    }
                  </button>
                </div>
              </div>

              {/* ── Filter offcanvas (desktop hidden panel / mobile drawer) ── */}
              {CatT.filter !== 0 && (
                <div
                  className={`offcanvas offcanvas-collapse offcanvas-start cat-offcanvas rounded-3 shadow mt-4 d-none ${Sidebar ? "show" : ""}`}
                  style={{ maxWidth: "22rem" }}
                >
                  <div className="offcanvas-header align-items-center">
                    <h2 className="h6 mb-0 text-white">
                      <i className="ri-equalizer-2-line me-2" />Filters
                    </h2>
                    <button className="btn-close" onClick={() => setIsSidebar(false)} />
                  </div>
                  <div className="offcanvas-body p-3">
                    {filteredPriceRanges.length > 0 && (
                      <div className="mb-4">
                        <p className="cat-filter-section-title">Price Range</p>
                        {filteredPriceRanges.map((range, i) => (
                          <div className="form-check mb-2" key={i}>
                            <input className="form-check-input" type="checkbox"
                              id={`price-${i}`}
                              value={`${range.min}-${range.max}`}
                              checked={selectedRanges.includes(`${range.min}-${range.max}`)}
                              onChange={handleCheckpriceboxChange} />
                            <label className="form-check-label cat-check-label" htmlFor={`price-${i}`}>
                              ₹{range.min.toLocaleString()} – ₹{range.max.toLocaleString()}
                            </label>
                          </div>
                        ))}
                      </div>
                    )}
                    {Attr.map((attr, i) => {
                      const hasVariations = products.some(
                        (p) => p?.variations && p.variations[attr.name] !== undefined
                      );
                      if (!hasVariations) return null;
                      return (
                        <div key={attr._id} className="mb-3">
                          <p className="cat-filter-section-title">{attr.name}</p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>

            {/* ── RIGHT: Main content ── */}
            <aside className="col-lg-9 col-md-8">

              {/* Hero banner */}
              {CatImage !== undefined && CatImage !== "" ? (
                <div className="cat-hero bg-transparent">
                  <img src={CatT?.slide_image ? CatT?.slide_image : CatImage } alt={CatT?.title || "Category"} />
                  <div className="cat-hero-text">
                    <div className="cat-breadcrumb">
                      <Link to="/">Home</Link> &nbsp;/&nbsp; {CatT?.title}
                    </div>
                    <h1>{CatT?.slide_head || CatT?.title}</h1>
                    {CatT?.slide_para && <p>{CatT.slide_para}</p>}
                  </div>
                </div>
              ) : (
                <div className="cat-hero-skeleton" />
              )}

              {/* Sub-categories */}
              {(isCat || Cat.length > 0) && (
                <div className="mt-4">
                  <div className="cat-section-tag">Sub-categories</div>
                  <div className="cat-sub-grid">
                    {isCat
                      ? Array.from({ length: 8 }).map((_, i) => (
                          <div key={i} className="cat-sub-skeleton" />
                        ))
                      : Cat.map((c) => (
                          <Link key={c._id || c.slug} to={`/${c.slug}`} className="cat-sub-card">
                            <img src={c.image} alt={c.title} loading="lazy" />
                            <span>{c.title}</span>
                            <p className="small px-2"> {c?.slide_para} </p>
                          </Link>
                        ))
                    }
                  </div>
                </div>
              )}

             
             
              {/* Static description (filter=0) */}
              {CatT.filter === 0 && (
                <div className="mt-4 bg-white rounded-3 p-4 border"
                  style={{ borderColor: "var(--cat-border)", lineHeight: 1.8 }}>
                  <div dangerouslySetInnerHTML={{ __html: CatT.description }} />
                </div>
              )}

          

 {(isCat || Cat.length === 0) && ( 
  <>

 {/* Toolbar */}
              {isCat && CatT.filter !== 0 && (
                <div className="cat-toolbar">
                  <div className="d-flex align-items-center gap-3 flex-wrap">
                    <span className="cat-toolbar-label">Show</span>
                    <select className="form-select cat-select" style={{ width: "auto" }}
                      value={count} onChange={handlecountChange}>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </select>
                    <span className="cat-toolbar-label">products</span>
                  </div>
                  <button className="cat-filter-btn d-lg-none" onClick={() => setIsSidebar(true)}>
                    <i className="ri-equalizer-2-line" /> Filters
                  </button>
                </div>
              )}


     {/* Active filter tags */}
              {Viewfillter && (() => {
                try {
                  const parsed = JSON.parse(Viewfillter);
                  const entries = Object.entries(parsed);
                  if (!entries.length) return null;
                  return (
                    <div className="d-flex flex-wrap gap-2 mb-3">
                      {entries.map(([key, value]) =>
                        value.split(",").map((val) => (
                          <button key={`${key}-${val}`} className="cat-filter-tag"
                            onClick={() => removeFilter({ key, val })}>
                            <span>{key}: {val}</span>
                            <i className="ri-close-line" />
                          </button>
                        ))
                      )}
                    </div>
                  );
                } catch { return null; }
              })()}


              {/* Product grid */}
              {CatT.filter !== 0 && (
                <div className="cat-products-grid mt-2">
                  {isCat
                    ? Array.from({ length: 8 }).map((_, i) => (
                        <div key={i} className="cat-prod-skeleton" />
                      ))
                    : Pro.map((item) => {
                        const productRatings = ratings.filter((r) => r.productId === item._id);
                        const totalRatings   = productRatings.length;
                        const avgRating      = totalRatings > 0
                          ? productRatings.reduce((a, c) => a + c.rating, 0) / totalRatings : 0;

                        return (
                          <div key={item._id} className="cat-prod-card">
                            {/* Badges */}
                            {/* <div className="cat-prod-badges">
                              <span className="cat-badge-sale">12% OFF</span>
                              <span className="cat-badge-top">Top</span>
                            </div> */}

                            {/* Hover actions */}
                            {/* <div className="cat-prod-actions">
                              <button className="cat-prod-action-btn" title="Add to wishlist">
                                <i className="ri-heart-line" />
                              </button>
                              <Link to="#" className="cat-prod-action-btn" title="Compare">
                                <i className="ri-repeat-line" />
                              </Link>
                            </div> */}

                            {/* Image */}
                            <Link to={`/product/${item.slug}`} className="cat-prod-img-wrap">
                              <img src={item.pImage} alt={item.title} loading="lazy" />
                            </Link>

                            {/* Body */}
                            <div className="cat-prod-body">
                              <h3 className="cat-prod-title">
                                <Link to={`/product/${item.slug}`}>{item.title}</Link>
                              </h3>
<p className="small"> {item?.shortpara}
 </p>
                           

                              {!isHeader && (
                                <div className="cat-contact-row">
                                  <a
                                    href={whatsappHref}
                                    className="cat-wa-btn"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <i className="ri-whatsapp-fill" /> WhatsApp
                                  </a>
                                  <Link to={callHref} className="cat-call-btn">
                                    <i className="ri-phone-line" /> Call
                                  </Link>
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })
                  }
                </div>
              )}

              {/* Empty state */}
              {Pro.length === 0 && !isCat && CatT.filter !== 0 && (
                <div className="cat-empty mt-3">
                  <i className="ri-inbox-2-line" />
                  <p>No products found in this category.</p>
                </div>
              )}

              {/* Pagination */}
              {!isCat && CatT.filter !== 0 && (
                <div className="cat-pagination">
                  <button className="cat-pg-btn" disabled={currentPage === 1}
                    onClick={() => handlePageChange(currentPage - 1)}>
                    <i className="ri-arrow-left-s-line" /> Previous
                  </button>
                  <span style={{ fontSize: ".85rem", color: "#888", fontWeight: 600 }}>
                    Page {currentPage}
                  </span>
                  <button className="cat-pg-btn" disabled={totalPages === 0}
                    onClick={() => handlePageChange(currentPage + 1)}>
                    Next <i className="ri-arrow-right-s-line" />
                  </button>
                </div>
              )}

               </>)}

            </aside>
          </div>

          {/* Description below grid (filter ≠ 0) */}
          {CatT.filter !== 0 && CatT.description && (
            <div className="mt-5 bg-white rounded-3 p-4 border"
              style={{ borderColor: "var(--cat-border)", lineHeight: 1.8 }}>
              <div dangerouslySetInnerHTML={{ __html: CatT.description }} />
            </div>
          )}

          {/* Specifications accordion */}
          {Specifications.length > 0 && Specifications.map((spec, si) => (
            <section key={si} className="cat-spec-section my-5">
              <h3 className="mb-4">{spec.heading}</h3>
              <div className="accordion" id={`acc-${si}`}>
                {spec.labels.map((label, li) => (
                  <div key={li} className="accordion-item cat-accordion-item">
                    <div className="accordion-header">
                      <button
                        className="accordion-button cat-accordion-btn collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#accBody-${si}-${li}`}
                        aria-expanded="false"
                      >
                        {label.label}
                      </button>
                    </div>
                    <div id={`accBody-${si}-${li}`} className="accordion-collapse collapse"
                      data-bs-parent={`#acc-${si}`}>
                      <div className="accordion-body" style={{ fontSize: ".9rem", lineHeight: 1.7 }}>
                        {label.value}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Category;
